<template>
    <DataTable :class="[ size ? 'p-datatable-' + size : '' ]" 
    :value="datas"
    stripedRows 
    :paginator="pagination" 
    :rows="rows" 
    :responsiveLayout="responsiveLayout" 
    breakpoint="414px" 
    :showGridlines="false" 
    :resizableColumns="false" 
    columnResizeMode="fit" 
    selectionMode="single" 
    v-model:selection="current_row" 
    @rowSelect="rowSelect" 
    :scrollable="!!height.length" 
    :scrollHeight="height"
    :style="height?`height: ${height}`:''">
        <!-- 序号：分页不正确 -->
        <Column header="" headerStyle="width: 70px;" bodyStyle="text-align: center" v-if="showRank">
            <template #body="slotProps">
                {{slotProps.index + 1}}
            </template>
        </Column>
        <Column v-for="column in columns" :key="column.field_name"
            :field="column.field_name"
            :header="column.caption"
            :style="{
                flex: height.length && column.edit_width ? `0 0 ${column.edit_width}px` : '',
                width: !height.length && column.edit_width ? `${column.edit_width}px` : 'auto',
                'max-width': '200px'
            }"
            :bodyStyle="{
                'overflow': 'hidden',
                'text-overflow': 'ellipsis',
                'white-space': 'nowrap'
            }"
            :sortable="sortable && ['string', 'number', 'date', 'boolean'].indexOf(column.data_type) > -1" 
            :frozen="!!column?.fixed?.length" 
            :alignFrozen="column?.fixed">
            <template v-if="column?.control_type === 'tw-switch'" #body="{data}">
                <InputSwitch style="pointer-events: none;" v-model="data[column.field_name]" />
            </template>
            <template v-else-if="column?.control_type === 'tw-checkbox'" #body="{data}">
                <Checkbox style="width:100%; pointer-events: none;" :value="data[column.field_name]" />
            </template>
            <template v-else-if="column?.control_type === 'tw-link'" #body="{data}">
                <tw-link :modelValue="data[column.field_name]" :underline="true" @click="rowLink(data)"></tw-link>
            </template>
            <template v-else-if="column?.display_format" #body="{data}">
                <span v-if="column?.data_type === 'number'">{{formatNumber(data[column.field_name], column.display_format)}}</span>
                <span v-else-if="column?.data_type === 'date'">{{formatDate(data[column.field_name], column.display_format)}}</span>
            </template>
        </Column>

        <ColumnGroup type="footer" v-if="showSummary">
            <Row v-if="summaryColumns.length">
                <Column v-for="column in columns" :key="column.field_name" :footer="summaryColumns[0][column.field_name]"></Column>
            </Row>
        </ColumnGroup>

        <template #empty>
            <div :style="{
                'line-height': `calc(${height} - ${size === 'lg' ? '48px - 30px' : '42px - 24px'})`
            }">
                暂无数据
            </div>
        </template>
    </DataTable>
</template>

<script>
import { computed, ref, watchEffect } from 'vue'
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import InputSwitch from 'primevue/inputswitch';
import Checkbox from 'primevue/checkbox';
import ColumnGroup from 'primevue/columngroup';
import Row from 'primevue/row';
import { formatNumber } from '../../utils/formatNumber'
import { formatDate } from '../../utils/formatDate'
import { calcSummary } from '../../utils/calcSummary'

export default {
    name: 'tw-grid-view',
    components: {
        DataTable,
        Column,
        InputSwitch,
        Checkbox,
        ColumnGroup,
        Row
    },
    setup(props, context) {
        const columns = computed(() => {
            return props.data_source && props.data_source.columns && props.data_source.columns.filter(el => {
                let visible = true
                // 需要注意如果无 visible 时也要显示，只有等于 False 时才不显示
                if (el.visible === false) {
                    visible = false
                } else {
                    // 如果指定分组，则只显示该分组的字段
                    if (props.group_name) {
                        visible = el.group_name === props.group_name
                    }
                }

                return visible
            }) || []
        })

        const datas = computed(() => {
            if (props.data_source && Array.isArray(props.data_source.datas)) {
                return props.data_source.datas.filter(item => item)
            } else {
                return []
            }
        })

        const showSummary = computed(() => {
            return columns.value.filter(el => !!el.summary_type).length !== 0
        })

        const summaryColumns = ref([])

        watchEffect(() => {
            if(showSummary.value){
                if (columns.value.length && datas.value.length) {
                    const _summary = {};

                    columns.value.forEach(column => {
                        _summary[column.field_name] = calcSummary(datas.value, column);
                    });

                    summaryColumns.value = [_summary];
                }else{
                    summaryColumns.value = []
                }
            }
        })

        const current_row = computed({
            get() {
                return props.data_source.current
            },
            set(value){
                if(value){
                    // eslint-disable-next-line vue/no-mutating-props
                    props.data_source.current = value
                }
            }
        })
        
        const rowSelect = (event) => {
            context.emit("current-change", event)
        }

        const rowLink = (row) => {
            context.emit("row-link", row)
        }

        return {
            columns,
            datas,
            showSummary,
            summaryColumns,
            current_row,
            formatNumber,
            formatDate,
            rowSelect,
            rowLink
        }
    },
    props: {
        data_source: {
            type: Object,
            default: function() {
                return { }
            }
        },
        group_name: {
            type: String,
            default: ''
        },
        size: String,
        responsiveLayout: {
            type: String,
            default: 'scroll'
        },
        pagination: {
            type: Boolean,
            default: false
        },
        rows: {
            type: Number,
            default: 10
        },
        sortable: {
            type: Boolean,
            default: false
        },
        height: {
            type: String,
            default: ''
        },
        showRank: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style>

</style>